import { AdminPvxPartnersListingItem, AdminPvxPartnersListingUser } from '@api/types/pvxPartners';
import { Row } from '../../../../components/GenericTable/GenericTable';
import { PvxPartnerTableRow } from '../hooks/usePvxPartnersTable';

const mapUserToTableRow = (
  user: AdminPvxPartnersListingUser,
  company: AdminPvxPartnersListingItem,
  index: number,
): Row<PvxPartnerTableRow> => ({
  id: user.membershipGrantId || `${company.clientCode}-${index}`,
  rowType: 'user',
  company: company.companyName,
  user: user.email,
  role: user.companyRole,
  dashboards: '',
  dashboardSubmoduleNames: (user.dashboardAccess?.submodules ?? []).map(
    (submodule) => submodule.submoduleName,
  ),
  totalEntitlementCount: user.dashboardAccess?.totalEntitlementCount,
  hasFullDashboardAccess: user.dashboardAccess?.hasFullAccess,
  joiningDate: user.joiningDate ?? '-',
  status: user.status,
  clientCode: company.clientCode,
  membershipGrantId: user.membershipGrantId,
  userId: user.userId,
  partnerType: company.partnerType,
});

export const mapPvxPartnersToTableRows = (
  items: AdminPvxPartnersListingItem[],
): Row<PvxPartnerTableRow>[] =>
  items.map((company) => ({
    id: company.clientCode,
    rowType: 'company',
    company: company.companyName,
    user: `${company.userCount} User${company.userCount === 1 ? '' : 's'}`,
    role: null,
    dashboards: '',
    dashboardSubmoduleNames: [],
    totalEntitlementCount: company.totalEntitlementCount,
    hasFullDashboardAccess: false,
    joiningDate: '-',
    status: '-',
    clientCode: company.clientCode,
    partnerType: company.partnerType,
    children: company.users.map((user, index) => mapUserToTableRow(user, company, index)),
  }));
